export { Menu5 as default } from './Menu5';
